import translations from './translations'

translations.add('es', {
    lookUp: 'Buscar mis tarjetas'
})
